module.exports = __webpack_public_path__ + "img/payment_cards.4ed50d7e.svg";